import merge from 'deepmerge';

export default (state = {
  // inital states here
  user: null,
  bondsData: {},
  rateData: {},
  userEmailVerificationSent: false,
}, action) => {
  if (action.response && action.response.entities) {
    return merge.all([state, action.response.entities], {
      clone: false,
      arrayMerge: (destinationArray, sourceArray) => sourceArray,
    });
  }

  return state;
};
